import { createAction } from '@reduxjs/toolkit'

import { typePagination, typeRequestPagination } from 'model/system/constants';

import {
    IdTransferCashDesksStateDataItem,
    typeTransferCashDesksFilters
} from 'model/dashboardTransferCashDesks/dTransferCashDesksReducer';

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set pagination
export const dTransferCashDesksSetPaginationAC = createAction(
    'D_TRANSFER_CASHDESKS_SET_PAGINATION',
    (
        pagination: typePagination,
    ) => ({payload: {pagination}})
)

// Action creator of set itemsForPage in pagination
export const dTransferCashDesksSetItemsForPageAC = createAction(
    'D_TRANSFER_CASHDESKS_SET_ITEMS_FOR_PAGE',
    (
        itemsForPage: number,
    ) => ( { payload: { itemsForPage } } )
)


// Action creator of set pageNumber in pagination
export const dTransferCashDesksSetPageNumberAC = createAction(
    'D_TRANSFER_CASHDESKS_SET_PAGE_NUMBER',
    (
        pageNumber: number,
    ) => ({payload: {pageNumber}})
)

// ---------------------------------------------------------------------------------------------------------------------


// Action creator of set data
export const dTransferCashDesksSetDataAC = createAction(
    'D_TRANSFER_CASHDESKS_SET_DATA',
    ( dataList: IdTransferCashDesksStateDataItem[] ) => ( { payload: { dataList } } )
)

// Action creator of saga set data
export const dTransferCashDesksSetDataSagaAC = createAction(
    'D_TRANSFER_CASHDESKS_SET_DATA_SAGA',
    (
        filters: typeTransferCashDesksFilters,
        paginationRequest: typeRequestPagination
    ) => ( { payload: {  filters,paginationRequest } } )
)

// ---------------------------------------------------------------------------------------------------------------------
// Action creator of set data detail
export const dTransferCashDesksSetDetailItemAC = createAction(
    'D_TRANSFER_CASHDESKS_SET_DETAIL_ITEM',
    ( detailItemId: string ) => ( { payload: detailItemId } )
)
// ---------------------------------------------------------------------------------------------------------------------
// Action creator of add item
export const dTransferCashDesksAddItemAC = createAction(
    'D_TRANSFER_CASHDESKS_ADD_ITEM',
    (detailItemObject: IdTransferCashDesksStateDataItem) => ({payload: detailItemObject})
)

// Action creator of saga add item
export const dTransferCashDesksAddItemSagaAC = createAction(
    'D_TransferCashDesks_ADD_SAGA_ITEM',
    (
        itemObject: {name: string, description: string, status: string},
        filters: typeTransferCashDesksFilters,


    ) => ({payload: {itemObject, filters}})
)



// ---------------------------------------------------------------------------------------------------------------------
// Action creator of clear filtersForm
export const dTransferCashDesksClearFiltersAC = createAction(
    'D_TRANSFER_CASHDESKS_CLEAR_FILTERS',
)

// Action creator of set filtersForm
export const dTransferCashDesksSetFiltersAC = createAction(
    'D_TRANSFER_CASHDESKS_SET_FILTERS',
    ( filterObj: typeTransferCashDesksFilters ) => ( { payload: filterObj } )
)

// Action creator of set filtersForm saga
export const dTransferCashDesksSetFiltersSagaAC = createAction(
    'D_TRANSFER_CASHDESKS_SET_FILTERS_SAGA',
    (
        filtersObject: typeTransferCashDesksFilters
    ) => ( { payload: { filtersObject } } )
)



